export const CloudflareInsights = ({ cfBeacon }) => {
    if (!cfBeacon)
        return null;
    return (<>
      {cfBeacon && (<script defer src="https://static.cloudflareinsights.com/beacon.min.js" data-cf-beacon={`{"token": "${cfBeacon}"}`}/>)}
    </>);
};
export default CloudflareInsights;
